import React from "react";
import "primeflex/primeflex.css";
import useCensus from "../../hooks/useCensus";
import ProFilter from "../common/ProFilter";

const ProCensusFilter = ({ toggleFilter }) => {
    
    const { data:{ filter }, actions:{ SetFilter, ResetFilter } } = useCensus({ refreshTree: false });

     return <ProFilter filter={filter} toggleFilter={toggleFilter} SetFilter={SetFilter} ResetFilter={ResetFilter}/>
   
}

export default ProCensusFilter